import { render, staticRenderFns } from "./SeminarSetPrice.vue?vue&type=template&id=56e4a9f4&scoped=true&"
import script from "./SeminarSetPrice.vue?vue&type=script&lang=js&"
export * from "./SeminarSetPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e4a9f4",
  null
  
)

export default component.exports